module.exports = __webpack_public_path__ + "img/cool-wallet.4c335d0a.svg";